<template>
	<section>
		<!-- 统计文字 -->
		<el-row class="statusRowWhite">
			<div class="RowChild">
				&nbsp;日期： &nbsp;
				<el-button type="primary" plain @click="changeDate(7)" id="yesterday">最近7天</el-button>
				<el-button type="primary" plain @click="changeDate(30)">最近30天</el-button>
			</div>
			<div class="RowChild">
				<el-date-picker class="xs24" v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="今天" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
			</div>
			<div class="RowChild">
				&nbsp;平台来源： &nbsp;
				<el-select class="xs24" v-model="pdata.platform_id" placeholder="请选择小游戏来源" @change="changePlatform" >
					<el-option :label="v.platform_name" :value="v.platform_id" v-for="(v,i) in get_issued_app_platform" :key="v.platform_id"></el-option>
				</el-select>
			</div>
			<div class="RowChild">
				&nbsp;小游戏名称： &nbsp;
				<el-select v-model="pdata.issued_app_id" filterable  clearable     placeholder="请选择小游戏名称">
			    <el-option
			      v-for="item in applist"
			      :key="item.id"
			      :label="item.name"
			      :value="item.id">
			    </el-option>
				</el-select>
				<!--<searchApp class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>-->
			</div>
			<div class="RowChild">
				&nbsp;操作： &nbsp;
				<el-button type="primary" @click="importData(1)">投放数据导入</el-button>
				<el-button type="primary" @click="importData(2)">发行数据导入</el-button>
				<el-button type="primary" @click="fieldConfig">字段选择</el-button>
			</div>
			<div class="RowChild">
				&nbsp;模板下载： &nbsp;
				<el-button size="medium" type="text" @click="downloadTemp(1)">投放数据导入模板下载</el-button>
				<el-button size="medium" type="text" @click="downloadTemp(2)">发行数据导入模板下载</el-button>
			</div>
		</el-row>
		

		<el-table :data="list" style="width: 100%;" stripe row-key="issued_app_id" v-if="list.length>0"  @expand-change="expands">

			<el-table-column type="expand"  prop="issued_app_name" label="" align="center">
				<template slot-scope="s"> 
 	  			  	<el-table :data="s.row.exData" :show-header="false" row-key="channel_id"  @expand-change="expandsChannel">
 	  			  		<el-table-column  prop="channel_name" label="" align="center" width="48px">&nbsp;</el-table-column>
 	  			  		<el-table-column type="expand"  prop="issued_app_name" label="" align="center" width="48px" v-if="dateVal[0]!==dateVal[1]">
 	  			  			<template slot-scope="ss">
 	  			  				<el-table :data="ss.row.exData" :show-header="false" row-key="d_date">
 	  			  					<el-table-column  prop="issued_app_name" label="" align="center" width="48px">&nbsp;</el-table-column>
 	  			  					<el-table-column  prop="issued_app_name" label="" align="center" width="48px">&nbsp;</el-table-column>
 	  			  					<el-table-column   prop="d_date" label="日期" align="center" width="150px"></el-table-column>
 	  			  					<el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList">
										<template slot-scope="scope">
											<span v-if="item.key=='origin_income'">--</span>
											<span v-else-if='["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key)>-1'>
												{{scope.row[item.key]||0}}%
											</span>
											<span v-else>{{scope.row[item.key]}}</span>
										</template>
									</el-table-column>
 	  			  				</el-table>
 	  			  			</template>	
 	  			  		</el-table-column>
 	  			  		<el-table-column  prop="channel_name" label="" align="center" width="48px" v-else>&nbsp;</el-table-column>
 	  			  		<el-table-column   prop="channel_name" label="渠道名称" align="center" width="150px"></el-table-column>
 	  			  		<el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList">
							<template slot-scope="scope">
								<span v-if="item.key=='origin_income'">--</span>
								<span v-else-if='["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key)>-1'>
									{{scope.row[item.key]||0}}%
								</span>
								<span v-else>{{scope.row[item.key]}}</span>
							</template>
						</el-table-column>
 	  			   	</el-table>
		 	  </template>		 
			</el-table-column>
			<el-table-column  prop="issued_app_name" label="" align="center" width="48px">&nbsp;</el-table-column>
			<el-table-column  prop="issued_app_name" label="发行名称" align="center" width="150px"></el-table-column>
			<el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList">
				<template slot="header" slot-scope="scope">
					<span>{{item.name}}</span>
				</template>
				<template slot-scope="scope">
					<span v-if='["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key)>-1'>
						{{scope.row[item.key]||0}}%
					</span>
					<span v-else>{{scope.row[item.key]}}</span>
				</template>
			</el-table-column>
			
		</el-table>

		<!--<el-table  style="width: 100%;" stripe row-key="id"  v-if="list.length==0"></el-table>-->
		<div class="el-table el-table--fit el-table--striped el-table--enable-row-hover" style="width: 100%;" v-if="list.length==0">
			<div class="el-table__body-wrapper is-scrolling-none">
				<div class="el-table__empty-block" style="height: 100%; width: 100%"><span class="el-table__empty-text">暂无数据</span></div>
			</div>
		</div>

		<el-pagination class="pagination" @size-change="SizeChange" @current-change="CurrentChange" :current-page.sync="pdata.page" :page-sizes="[20, 40, 60, 80]" :page-size="pdata.perpage" background layout="sizes, prev, pager, next, jumper" :total="pdata.perpage*maxPage"></el-pagination>
		
		<el-row  class="totalBox">
			<el-col :span="4" class="lh45 tc h45">合计</el-col>
			<el-col :span="4" class="lh45 tc h45">花费</el-col>
			<el-col :span="4" class="lh45 tc h45">新增</el-col>
			<el-col :span="4" class="lh45 tc h45">活跃</el-col>
			<el-col :span="4" class="lh45 tc h45">活跃单价</el-col>
			<el-col :span="4" class="lh45 tc h45">新增单价</el-col>
			
		</el-row>
		<el-row  class="totalBox">
			<el-col :span="4" class="lh45 tc h45"></el-col>
			<el-col :span="4" class="lh45 tc h45">{{total.gdt_cost}}</el-col>
			<el-col :span="4" class="lh45 tc h45">{{total.visit_uv_new}}</el-col>
			<el-col :span="4" class="lh45 tc h45">{{total.visit_uv}}</el-col>
			<el-col :span="4" class="lh45 tc h45">{{total.visit_uv_price}}</el-col>
			<el-col :span="4" class="lh45 tc h45">{{total.visit_uv_new_price}}</el-col>
			
		</el-row>
		<el-drawer title="我是标题" size="580px" :visible.sync="drawer" direction="rtl" :with-header="false">
			<div class="filedFlex">
				<div class="fliedLeft">
					<div class="tit">设置显示字段</div>
					<div class="des">可选字段</div>
					<div class="fliedBtns" v-for="(value,key) in fieldList">
						<div class="key">{{key}}</div>
						<div class="btnsbox">

							<el-button :type="item.isCheck?'primary':''" :plain="item.isCheck?false:true" size="mini" v-for="(item,index) in value" @click.native="fliedTap(key,index)" :autofocus="false">{{item.name}}</el-button>

						</div>

					</div>
					<div class="fliedFt">
						<el-button type="success" @click="saveSelectField">确认并保存</el-button>
					</div>
				</div>
				<div class="fliedRight">
					<div class="tit">已选字段</div>
					<draggable v-model="selectFieldList" :move="onMove" @start="isDragging=true" @end="isDragging=false">
						<transition-group type="transition" tag="ul">
							<li v-for="item in selectFieldList" :key="item.key" class="item">
								<i class="el-icon-rank"></i> {{item.name}}
								<i class="el-icon-close" @click="removeSelectField(item)"></i>
							</li>
						</transition-group>
					</draggable>
				</div>
			</div>
		</el-drawer>

		<el-dialog title="导入" :visible.sync="batchDialog" width="650px" :close-on-click-modal="false">
			<el-form ref="ruleForm" label-width="140px">
				<el-upload v-if="batchForm.length==0" class="upload-demo" drag :action="url" :headers="headers" :on-success="batchSuccess" name="file" :show-file-list="false">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					<div class="el-upload__tip" slot="tip">只能上传csv文件</div>
				</el-upload>
			</el-form>
			<el-row :gutter="5" class="yltt" v-if="batchForm.length>0">
				<el-col :span="24">{{batchTips==0?'导入预览':'以下数据导入失败'}}</el-col>
			</el-row>
			
			<el-row :gutter="5" v-for="item,index in batchForm" :key="index" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0&&importType==1">
				<el-col :span="4" v-for="(citem,idx) in  item" :key="idx">
					{{citem}}
				</el-col>

			</el-row>
			<el-row :gutter="5" v-for="item,index in batchForm" :key="index" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0&&importType==2">
				<el-col :span="6" v-for="(citem,idx) in  item" :key="idx">
					{{citem}}
				</el-col>

			</el-row>
			<div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
				<el-button @click="batchCalcel">取 消</el-button>
				<el-button type="primary" @click="batchSubmit" v-if="batchTips=='0'">确认</el-button>
				<el-button type="primary" @click="batchSubmit" v-if="batchTips=='1'">知道了</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import $ from "jquery";
	import { getGDBackTList, getfieldFilter, postfieldFilter, baseUrl,batchGDTAddTF,batchGDTAddFX,getGDBackTListChannel, getGDBackTListChannelDate,getIssuedAppList, getValidProductPlatform } from "../../api/api";
	import draggable from 'vuedraggable'

	export default {

		components: {
			draggable
		},
		data() {
			return {
				chartColumn: null,
				pholder: "",
				pdata: {
					page: 1,
					perpage: 20,
					platform_id:1,
					issued_app_id: "137",
					kw: "",
					sdate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
						.toISOString()
						.slice(0, 10),
					edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
						.toISOString()
						.slice(0, 10)
					// sdate: "2019-04-15",
					// edate: "2019-04-15",
				},
				tText: "请选择创意类型",
				plist: [],
				applist:[],
				maxPage: 1,
				config: [],
				editDialog: false,
				batchForm: [],
				url: baseUrl + "/issuedAldChannelGdt/previewTf",
				headers: {
					'token': this.$cookie.getCookie("login")
				},
				batchDialog: false,
				batchTips: 0,
				importType: '',
				checks: [],
				isIndeterminate: false,
				checkAll: false,
				group: {},

				dateVal: [
					new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
					.toISOString()
					.slice(0, 10),
					new Date(new Date().getTime() - 3600 * 1000 * 24)
					.toISOString()
					.slice(0, 10)
				],
				pickerOptions: {
					shortcuts: [{
							text: "昨天",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24);
								picker.$emit("pick", [start, start]);
							}
						},
						{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							}
						}
					]
				},
				list: [], //所有数据
				total:{}, //合计
				get_issued_app_platform:[],
				height: 900,
				drawer: false, //默认不展开

				fieldList: {
					'用户数据': [{
							"name": "新增",
							"key": "visit_uv_new",
							"isCheck": false
						},
						{
							"name": "活跃",
							"key": "visit_uv",
							"isCheck": false
						},
						{
							"name": "新增占比",
							"key": "visit_uv_new_per",
							"isCheck": false
						},
						{
							"name": "点击数",
							"key": "gdt_click",
							"isCheck": false
						},
						{
							"name": "流失",
							"key": "leave",
							"isCheck": false
						},
						{
							"name": "新增跳出率",
							"key": "visit_uv_new_jump",
							"isCheck": false
						},
						{
							"name": "活跃跳出率",
							"key": "visit_uv_jump",
							"isCheck": false
						}
					],
					'收支数据': [{
							"name": "获客点击单价",
							"key": "click_price",
							"isCheck": false
						},
						{
							"name": "新增单价",
							"key": "visit_uv_new_price",
							"isCheck": false
						},
						{
							"name": "活跃单价",
							"key": "visit_uv_price",
							"isCheck": false
						},
						{
							"name": "新增arpu",
							"key": "visit_uv_new_arpu",
							"isCheck": false
						},
						{
							"name": "活跃arpu",
							"key": "visit_uv_arpu",
							"isCheck": false
						},
						{
							"name": "原生收入",
							"key": "origin_income",
							"isCheck": false
						},
						{
							"name": "原生arpu",
							"key": "origin_arpu",
							"isCheck": false
						},
						{
							"name": "收入",
							"key": "gdt_income",
							"isCheck": false
						},
						{
							"name": "花费",
							"key": "gdt_cost",
							"isCheck": false
						}
					],
					'回收': [{
							"name": "新增当日回收",
							"key": "visit_uv_new_back_0",
							"isCheck": false
						},
						{
							"name": "活跃当日回收",
							"key": "visit_uv_back_0",
							"isCheck": false
						},
						{
							"name": "累计当日回收",
							"key": "total_back_0",
							"isCheck": false
						}
					]
				},
				selectFieldList: [],
				showFieldList: [],
			};
		},
		watch: {
			dateVal: {
				handler(n, o) {
					if(n[0]) {
						this.pdata.sdate = n[0];
						this.pdata.edate = n[1];
						this.getField();
					}
				},
				deep: true
			},
			"pdata.issued_app_id": {
		    	handler(n, o) {
		    		debugger
		      	this.getField();
		    	},
		      deep: true
		    },
		},
		methods: {
			expands(r, es) {
		      var isshou = false;
		      if (es.length > 0) {
		        es.forEach(v => {
		          if (v.issued_app_id == r.issued_app_id) {
		            isshou = true;
		          }
		        });
		      }
		      if (isshou) {
		        var p = `issued_app_id=${r.issued_app_id}&sdate=${this.dateVal[0]}&edate=${
		          this.dateVal[1]
		        }`;
		
		        getGDBackTListChannel(p, this.$cookie.getCookie("login")).then(res => {
		          if (res.code == 200) {
		          	if(res.data.list&&res.data.list.length>0){
		          		 res.data.list.forEach((v,i)=>{
		          		 	v.keyid='ckey'+i;
				            v.exData = [];
		          		 })
		          		 r.exData = res.data.list;
		          		
		          	}
		          	else{
		          		 r.exData=[];
		          	}
		           
		            this.$forceUpdate();
		          }
		        });
		      }
		    },
		    expandsChannel(r, es) {
		      var isshou = false;
		      if (es.length > 0) {
		        es.forEach(v => {
		          if (v.channel_id == r.channel_id) {
		            isshou = true;
		          }
		        });
		      }
		      if (isshou) {
		        var p = `issued_app_id=${r.issued_app_id}&channel_id=${r.channel_id}&sdate=${this.dateVal[0]}&edate=${
		          this.dateVal[1]
		        }`;
		
		        getGDBackTListChannelDate(p, this.$cookie.getCookie("login")).then(res => {
		          if (res.code == 200) {
		          	 res.data.list.forEach((v,i)=>{
	          		 	v.keyid='dkey'+i;
			            v.exData = [];
	          		 })
		            r.exData = res.data.list;
		            this.$forceUpdate();
		          }
		        });
		      }
		    },
			downloadTemp(type) {
				if(type == 1) {
					window.location.href = '/static/tfdata.csv';
				} else {
					window.location.href = '/static/fxdata.csv';
				}
			},
			importData(type) {
				this.batchDialog = true;
				this.importType = type;
				if(type==1){
					this.url =  baseUrl + '/issuedAldChannelGdt/previewTf'
				}
				else if(type==2){
					this.url =  baseUrl + '/issuedAldChannelGdt/previewFx'
				}

			},
			batchSuccess(response, file, fileList) {
				if(response.code == 200) {
					this.batchForm = response.data;
				}
			},
			batchCalcel() {
				this.batchDialog = false;
				this.batchForm = [];
				this.batchTips = 0;
			},
			batchSubmit() {
				var p = {
					"data": this.batchForm
				};
				if(this.importType==1){
					batchGDTAddTF(p, this.$cookie.getCookie("login")).then(response => {
						if(response.code == 200) {
							if(response.data.length > 1) {
								this.batchForm = response.data;
								this.batchTips = "1";
							} else {
								this.$message({
									message: "导入成功",
									type: "success"
								});
								this.batchDialog = false;
								this.batchForm = [];
								this.getList()
							}
						} else {
							
							this.$message.error('导入失败');
						}
					});
					
				}
				else if(this.importType==2){
					batchGDTAddFX(p, this.$cookie.getCookie("login")).then(response => {
					if(response.code == 200) {
						if(response.data.length > 1) {
							this.batchForm = response.data;
							this.batchTips = "1";
						} else {
							this.$message({
								message: "导入成功",
								type: "success"
							});
							this.batchDialog = false;
							this.batchForm = [];
							this.getList()
						}
					} else {
						this.$message.error('导入失败');
					}
				});
					
				}
				
			},

			getField() {
				var _this = this;
				var p = "position=gdt_index";
				getfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					console.log(res.data.content);
					if(res.data.content.length == 0) {
						//游戏名 新增	活跃 	获客点击单价	活跃单价	活跃跳出	活跃arpu	原生arpu	 活跃当日回收	累计当日回收
						res.data.content = ['visit_uv_new', 'visit_uv', 'click_price', 'visit_uv_price', 'visit_uv_jump', 'origin_arpu', 'visit_uv_back_0', 'total_back_0'];
					}
					_this.selectFieldList = [];
					_this.showFieldList = [];
					_this.list = [];
					res.data.content.forEach((vv, ii) => {
						for(var key in _this.fieldList) {
							_this.fieldList[key].forEach((v, i) => {

								if(vv == v.key) {
									v.isCheck = true;
									_this.selectFieldList.push(v);
								}
							})
						}
					});
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getList();
				})
			},
			saveSelectField() {
				var tempArr = [];
				this.selectFieldList.forEach((v, i) => {
					tempArr.push(v.key);
				})
				var p = {
					position: 'gdt_index',
					content: tempArr,
				}
				postfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					this.drawer = false;
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getField();

				})
			},
			removeSelectField(obj) {
				this.removeArrForObjName(this.selectFieldList, obj);
				var fieldList_key;
				var fieldList_index;
				for(let key in this.fieldList) {
					this.fieldList[key].some((item, index) => {
						if(item.name == obj.name) {
							fieldList_key = key;
							this.fieldList[key][index].isCheck = false;

						}
					})
				}

			},
			onMove({
				relatedContext,
				draggedContext
			}) {
				const relatedElement = relatedContext.item;
				const draggedElement = draggedContext.item;
			},
			fieldConfig() {
				this.drawer = true
			},
			fliedTap(key, index) {
				this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
				var result = this.selectFieldList.some(item => {
					if(item.name == this.fieldList[key][index].name) {
						return true
					}
				})
				if(this.fieldList[key][index].isCheck) {
					if(!result) {
						this.selectFieldList.push(this.fieldList[key][index])
					}
				} else {
					if(result) {
						this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index])
					}
				}
			},
			removeArrForObjName(_arr, _obj) {
				var length = _arr.length;
				for(var i = 0; i < length; i++) {
					if(_arr[i].name == _obj.name) {
						_arr.splice(i, 1); //删除下标为i的元素
						return _arr;
					}
				}
			},
			handleCheckAllChange(val) {
				this.checks = val ? this.checklist : [];
				this.isIndeterminate = false;
			},
			handleCheckedChange(value) {

				let checkedCount = value.length;
				this.checkAll = checkedCount === this.checklist.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist.length;
				this.checks = value;
			},
			changeDate(s) {
				this.dateVal = [
					new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
					.toISOString()
					.slice(0, 10),
					new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
					.toISOString()
					.slice(0, 10)
				];
				// this.getList();
			},
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if(index === 0) {
						sums[index] = '合计';
						return;
					}
					if(index === 3 || index === 4 || index === 5 || index === 7 || index == 11 || index === 12 || index === 8) {
						sums[index] = 'N/A';
						return;
					}

					const values = data.map(item => Number(item[column.property]));
					if(!values.every(value => isNaN(value))) {
						if(index === 6 || index === 9 || index === 10 || index === 13 || index === 15 || index === 16) {
							sums[index] = '￥' + values.reduce((prev, curr) => {
								const value = Number(curr);
								if(!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0).toFixed(2);
						} else {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if(!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0).toFixed(2);
						}

					} else {
						sums[index] = 'N/A';
					}
				});

				return sums;
			},
			getList() {
				var p = "";
				for(var k in this.pdata) {
					// if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
					if(this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
				}
				getGDBackTList(p, this.$cookie.getCookie("login")).then(res => {
					if(res.code == 200) {
						// "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
						if(res.data.list && res.data.list.length > 0) {
							 res.data.list.forEach((x,i) => {
				            	x.keyid='key'+i;
				              	x.exData = [];
				            });
							this.list = res.data.list;
							this.total = res.data.total;
							this.maxPage = res.data.count;
						} else {
							this.list = [];
							
							this.maxPage = 1;
						}

					}
//					else{
//						this.list=[{'issued_app_name':'Mock字段','visit_uv_new':'1', 'visit_uv':'1', 'click_price':'1', 'visit_uv_price':'1', 'visit_uv_jump':'1', 'origin_arpu':'1', 'visit_uv_back_0':'1', 'totle_back_0':'1'}]
//						this.list.forEach((x,i) => {
//			            	x.keyid='key'+i;
//			             	x.exData = [{'issued_app_name':'Mock渠道名称','visit_uv_new':'1', 'visit_uv':'1', 'click_price':'1', 'visit_uv_price':'1', 'visit_uv_jump':'1', 'origin_arpu':'1', 'visit_uv_back_0':'1', 'totle_back_0':'1'}];
//			            	x.exData.forEach((xx,ii)=>{
//			            		xx.keyid='keyxx'+ii;
//			            		xx.exData= [{'issued_app_name':'Mock20200202','visit_uv_new':'1', 'visit_uv':'1', 'click_price':'1', 'visit_uv_price':'1', 'visit_uv_jump':'1', 'origin_arpu':'1', 'visit_uv_back_0':'1', 'totle_back_0':'1'}];
//			            	})
//						});
//					}
				});
			},
			SizeChange(v) {
				this.pdata.perpage = v;
				this.getList();
			},
			CurrentChange(v) {
				this.pdata.page = v;
				this.getList();
			},
			changeDate(s) {
				this.dateVal = [
					new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
					.toISOString()
					.slice(0, 10),
					new Date(new Date().getTime() - 3600 * 1000 * 24)
					.toISOString()
					.slice(0, 10)
				];
				// this.getList();
			},
			changeId(res) {
				this.pdata.issued_app_id = res;
				this.getField();
			},
			getPlatFormList(){
				var p='';
				getValidProductPlatform(p, this.$cookie.getCookie("login")).then(res=>{
					if(res.code == 200) {					
						this.get_issued_app_platform = res.data;
					}
				})
				
			},
			changePlatform(){
				this.applist=[];
				this.pdata.issued_app_id ='';
				this.getAppList();
				this.getField();
				this.getAppList();
			},
			getAppList(){
		
				getIssuedAppList(
		          "page=1&perpage=1000&kw=issued&platform_id="+this.pdata.platform_id,
		          this.$cookie.getCookie("login")
		        ).then(res => {
		        
		          if (res.code == 200) {
		          	this.applist =res.data;
		          	
		            this.getField();
		          }
		        });
			},
			
		},

		created() {

			console.log($(window).height() - 200);
			this.height = $(window).height() - 200
		},

		mounted() {

			if(Object.keys(this.$route.params).length > 0) {
				this.pdata.sdate = this.$route.params.sdate;
				this.pdata.edate = this.$route.params.edate;
			}
			this.getPlatFormList();
			this.getAppList();
			
		}
	};
</script>

<style lang="scss">
	.el-button+.el-button {
		margin-left: 0;
	}
	
	#chart>div {
		margin: 0 auto;
	}

</style>

<style scoped="scoped" type="text/css">
	.totalBox{
		background:#f5f5f5;
	}
	.tc{
		text-align: center;
	}


	.lh45{
		line-height: 45px;
	}
	.h45{
		height: 45px;
	}
	.red {
		color: #FF0000;
	}
	
	.filedFlex {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		height: 100%;
	}
	
	.fliedLeft {
		width: 360px;
		border-right: 1px solid #E6E6E6;
		box-sizing: border-box;
		height: 100vh;
		overflow-y: auto;
	}
	
	.fliedRight {
		width: 220px;
		height: 100vh;
		overflow-y: auto;
	}
	
	.tit {
		padding: 0 10px;
		text-align: left;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		border-bottom: 1px solid #E6E6E6;
	}
	
	.filedFlex .des {
		padding: 0 15px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
	}
	
	.filedFlex .key {
		padding: 0 15px;
		font-size: 14px;
		height: 50px;
		line-height: 50px;
		font-weight: bold;
	}
	
	.btnsbox {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
		padding: 5px;
	}
	
	.btnsbox button {
		margin: 5px;
	}
	
	.btnsbox button:focus {}
	
	.fliedRight ul {
		margin: 0;
		padding: 0;
	}
	
	.fliedRight ul li {
		line-height: 40px;
		list-style: none;
		border-bottom: 1px solid #E6E6E6;
		padding: 0 10px;
	}
	
	.fliedRight ul li i {
		margin-right: 5px;
	}
	
	.fliedRight ul li i.el-icon-close {
		float: right;
		cursor: pointer;
		margin-top: 15px;
	}
	
	.fliedFt {
		margin: 20px 0;
		padding: 0 10px;
	}
</style>


// WEBPACK FOOTER //
// gdtDataList.vue?55102748